"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Radio = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var utils_1 = require("./utils");
var spacing_1 = require("../spacing");
var grid_1 = require("../grid");
var __1 = require("../..");
var HoverContainer = (0, styled_components_1.default)(grid_1.Container)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex-wrap: nowrap;\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  * {\n    &:hover {\n      cursor: pointer;\n    }\n  }\n"], ["\n  flex-wrap: nowrap;\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  * {\n    &:hover {\n      cursor: pointer;\n    }\n  }\n"])));
var RadioStyle = (0, styled_components_1.default)(spacing_1.Div)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  &:hover {\n    cursor: pointer;\n  }\n\n  height: 20px;\n  width: 20px;\n\n  input[type='radio'] {\n    ", "\n\n    box-sizing: content-box;\n    position: relative;\n    padding: 0;\n    appearance: none;\n    height: 20px;\n    width: 20px;\n    border-radius: 50%;\n    border: 1px solid ", ";\n\n    &:checked {\n      border-color: ", ";\n\n      &:after {\n        content: '';\n        position: absolute;\n        height: 10px;\n        width: 10px;\n        top: 25%;\n        left: 25%;\n        right: 25%;\n        bottom: 25%;\n        background-color: ", ";\n        border-radius: 50%;\n      }\n    }\n  }\n"], ["\n  &:hover {\n    cursor: pointer;\n  }\n\n  height: 20px;\n  width: 20px;\n\n  input[type='radio'] {\n    ", "\n\n    box-sizing: content-box;\n    position: relative;\n    padding: 0;\n    appearance: none;\n    height: 20px;\n    width: 20px;\n    border-radius: 50%;\n    border: 1px solid ", ";\n\n    &:checked {\n      border-color: ", ";\n\n      &:after {\n        content: '';\n        position: absolute;\n        height: 10px;\n        width: 10px;\n        top: 25%;\n        left: 25%;\n        right: 25%;\n        bottom: 25%;\n        background-color: ", ";\n        border-radius: 50%;\n      }\n    }\n  }\n"])), utils_1.inputStyle, function (_a) {
    var theme = _a.theme;
    return theme.colors.grayBorder;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary;
});
exports.Radio = react_1.default.forwardRef(function (_a, forwardedRef) {
    var _b = _a.styledProps, styledProps = _b === void 0 ? {} : _b, _c = _a.containerProps, containerProps = _c === void 0 ? {} : _c, children = _a.children, nativeProps = __rest(_a, ["styledProps", "containerProps", "children"]);
    var radio = (0, react_1.useRef)(null);
    var ref = nativeProps.ref, props = __rest(nativeProps, ["ref"]);
    var input = (react_1.default.createElement(RadioStyle, __assign({}, styledProps),
        react_1.default.createElement("input", __assign({}, props, { ref: (0, __1.mergeRefs)(radio, ref, forwardedRef), type: "radio", onClick: function (e) { return e.stopPropagation(); } }))));
    if (children) {
        return (react_1.default.createElement(HoverContainer, __assign({ align: "center", onClick: function () { return radio.current.click(); }, grow: true }, containerProps),
            react_1.default.createElement(spacing_1.Div, { pr: 1 }, input),
            children));
    }
    return input;
});
exports.default = exports.Radio;
var templateObject_1, templateObject_2;
//# sourceMappingURL=Radio.js.map